const INDIA_BLOG_TERMS = [
  "bangalore",
  "bengaluru",
  "kochi",
  "kerala",
  "india",
  "indian",
  "nri",
  "monsoon",
  "gst",
  "₹",
  "+91",
];

const getSearchableText = (value) => {
  if (!value) return "";
  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value.map(getSearchableText).join(" ");
  }
  if (typeof value === "object") {
    return Object.values(value).map(getSearchableText).join(" ");
  }
  return "";
};

export const isIndiaRelatedBlog = (post) => {
  const text = getSearchableText(post).toLowerCase();
  return INDIA_BLOG_TERMS.some((term) => text.includes(term));
};

export const filterBlogsForRegion = (posts, isUSRoute) => {
  if (!isUSRoute) return posts;
  return posts.filter((post) => !isIndiaRelatedBlog(post));
};
